/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { WhiteSpace } from "antd-mobile";
import { Route, Redirect, Switch } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Theme from "../../utils/Theme";
import Topbar from "./Topbar";
import logo from "../../assets/logo-square-transparent.png";
import LoginSection from "./LoginSection";
import SignupSection from "./SignupSection";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth};
  background: white;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledTopbarContainer = styled.div`
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const StyledLogo = styled.img`
  width: 60%;
`;

const StyledContentContainer = styled(Switch)`
  display: flex;
  flex: 1;
`;

class AuthPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null
    };
  }

  componentDidMount() {
    this.setState({ animationClass: "slide-in-down" });
  }

  onSkipPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-down" });

    window.setTimeout(() => {
      history.push("/shop");
    }, 300);
  };

  render() {
    const { animationClass } = this.state;
    const { history, location, match } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        <StyledTopbarContainer>
          <Topbar
            onLeftIconClick={() => history.goBack()}
            onRightIconClick={() => this.onSkipPressed()}
            backButton={location.pathname === "/auth/signup"}
          />
        </StyledTopbarContainer>
        <WhiteSpace size={"xl"} />
        <WhiteSpace size={"xl"} />
        <StyledLogoContainer>
          <StyledLogo src={logo} alt="lsquare-logo" />
        </StyledLogoContainer>
        <WhiteSpace size={"xl"} />
        <TransitionGroup>
          <CSSTransition key={location.key} timeout={300} classNames="fade">
            <StyledContentContainer>
              <Route path="/auth/login" component={LoginSection} />
              <Route
                path="/auth/signup"
                render={props => <SignupSection {...props} />}
              />
              <Route
                exact
                path="/auth/"
                render={() => <Redirect to="/auth/login" />}
              />
              <Route render={() => <Redirect to="/not-found" />} />
            </StyledContentContainer>
          </CSSTransition>
        </TransitionGroup>
      </StyledContainer>
    );
  }
}

AuthPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default AuthPage;



// WEBPACK FOOTER //
// ./src/containers/AuthPage/index.js